import React from 'react';
import { SmartGoalSelector } from '../../common/SmartGoalSelector';
import { SmartGoal } from 'src/models/form-types';
import '../../../../styles/components/forms/smart-goal-selector.css';

interface FormValidation {
  isPurposeValid: boolean;
  isLearningSupportValid: boolean;
  isAdditionalInfoValid: boolean;
  isLevelOfAdjustmentValid: boolean;
  isBehavioursValid: boolean;
  isBehaviourContextValid: boolean;
  isBehaviourFunctionValid: boolean;
}

interface SmartGoalsSectionProps {
  goals: SmartGoal[];
  isLoading: boolean;
  error: string | null;
  onGenerateGoals: () => Promise<void>;
  onGoalSelect: (goal: string) => void;
  isFormValid: boolean;
  formValidation: FormValidation;
  className?: string;
}

export const SmartGoalsSection: React.FC<SmartGoalsSectionProps> = ({
  goals,
  isLoading,
  error,
  onGenerateGoals,
  onGoalSelect,
  isFormValid,
  formValidation,
  className,
}) => {
  return (
    <SmartGoalSelector
      goals={goals}
      isLoading={isLoading}
      error={error}
      onGenerateGoals={onGenerateGoals}
      onGoalSelect={onGoalSelect}
      isFormValid={isFormValid}
      formValidation={formValidation}
      className={className}
    />
  );
};
